import { ChangeEvent, useContext, useRef, useState } from "react";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import { CHOOSE_PATHWAY, CANCEL, ADD_PATIENT_DETAILS_STEP_2, CONTINUE } from "../../util/const";
import { HomePageProps} from "../PatientList";
import PatientForm from "../PatientForm";
import UnlinkedParticipants from "../UnlinkedParticipants";
import { PatientContext, DefaultPatient } from "../ActivePatients";

export type StepOneProps = {
  toggleDisplay: (didSave: boolean) => void;
  isEditing: boolean;
  title?: string;
};

const CreatePatient = (props: HomePageProps) => {

  const context = useContext(PatientContext);

  var isRegistered = useRef(false);

  const [item, setItem] = useState({ ticked: "" });
  const { ticked } = item;

  const handleChange = (e:ChangeEvent<HTMLInputElement>, registered: boolean) => {
    e.persist();

    setItem(prevState => ({
      ...prevState,
      ticked: e.target.value
    }));

    isRegistered.current = registered;
  };

  const [isContinuing, setIsContinuing] = useState(false);
  const toggleContinuing = (didLink: boolean) => {
    if(didLink)
      props.toggleDisplay(didLink);
    else
      setIsContinuing(!isContinuing);
  }

  if (isContinuing) {
    if (isRegistered.current) {
      return <UnlinkedParticipants toggleDisplay={toggleContinuing} />;
    } else {
      context.patient = DefaultPatient();
      return <PatientForm toggleDisplay={props.toggleDisplay} title={ADD_PATIENT_DETAILS_STEP_2} isEditing={false} />;
    }
  }

  return (
    <Card className="mt-3 mb-3" border="secondary" text="white">
      <Card.Header className="fs-5 app-colour">
        <Row>
          <Col>{CHOOSE_PATHWAY}</Col>
          <Col className="right">
            <Button
              type="button"
              onClick={(e) => props.toggleDisplay(false)}
              className="fs-6 btn-outline-white">
              {CANCEL}
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="color-text fs-5 text-center">
        <div className="mt-4">Has the patient registered to use the MoTHer mobile app?</div>
        <Form className="mt-4">
          <Form.Check
            inline
            type="radio"
            id="radio-yes"
            label="Yes"
            value="yes"
            onChange={(e) => handleChange(e, true)}
            checked={ticked === "yes"}
          />
          <Form.Check
            inline
            type="radio"
            id="radio-no"
            label="No"
            value="no"
            onChange={(e) => handleChange(e, false)}
            checked={ticked === "no"}
          />
          <div className="mt-4 mb-4">
            <Button type="button" onClick={(e) => toggleContinuing(false)} className="btn-color">
              {CONTINUE}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default CreatePatient;